const movieMini = {
    id: "",
    imageUrl: "",
    name: "",
    year: 0,
    rating: 0
}

export default movieMini;